module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/crocodile-pic.24247602.png";